export class Block {

    name = "";
    key = "";
    rows = [];
    colType = "0"
    columns = [];
}
